import { enTag, esTag } from './languages'

const en = require('../locales/common/commonEn.json')
const es = require('../locales/common/commonEs.json')

const adOpsEn = require('../locales/adOps/adOpsEn.json')
const adOpsEs = require('../locales/adOps/adOpsEs.json')
const apiKeysEn = require('../locales/apiKeys/apiKeysEn.json')
const apiKeysEs = require('../locales/apiKeys/apiKeysEs.json')
const bluebookEn = require('../locales/bluebook/bluebookEn.json')
const bluebookEs = require('../locales/bluebook/bluebookEs.json')
const cardsEn = require('../locales/cards/cardsEn.json')
const cardsEs = require('../locales/cards/cardsEs.json')
const carouselEn = require('../locales/carousel/carouselEn.json')
const carouselEs = require('../locales/carousel/carouselEs.json')
const cashoutEn = require('../locales/cashout/cashoutEn.json')
const cashoutEs = require('../locales/cashout/cashoutEs.json')
const cashoutDetailEn = require('../locales/cashoutDetail/cashoutDetailEn.json')
const cashoutDetailEs = require('../locales/cashoutDetail/cashoutDetailEs.json')
const changeMccEn = require('../locales/changeMcc/changeMccEn.json')
const changeMccEs = require('../locales/changeMcc/changeMccEs.json')
const chargebacksEn = require('../locales/chargebacks/chargebacksEn.json')
const chargebacksEs = require('../locales/chargebacks/chargebacksEs.json')
const chargebackSummaryEn = require('../locales/chargebackSummary/chargebackSummaryEn.json')
const chargebackSummaryEs = require('../locales/chargebackSummary/chargebackSummaryEs.json')
const cleanStorageEn = require('../locales/pages/cleanStorageEN.json')
const cleanStorageEs = require('../locales/pages/cleanStorageES.json')
const companyDraftEn = require('../locales/companyDraft/companyDraftEn.json')
const companyDraftEs = require('../locales/companyDraft/companyDraftEs.json')
const companyProfileEn = require('../locales/companyProfile/companyProfileEn.json')
const companyProfileEs = require('../locales/companyProfile/companyProfileEs.json')
const contractEn = require('../locales/contract/contractEn.json')
const contractEs = require('../locales/contract/contractEs.json')
const createCompanyEn = require('../locales/createCompany/createCompanyEn.json')
const createCompanyEs = require('../locales/createCompany/createCompanyEs.json')
const customerDetailEn = require('../locales/customerDetail/customerDetailEn.json')
const customerDetailEs = require('../locales/customerDetail/customerDetailEs.json')
const customerEn = require('../locales/customers/customerEn.json')
const customerEs = require('../locales/customers/customerEs.json')
const dashboardEn = require('../locales/dashboard/dashboardEn.json')
const dashboardEs = require('../locales/dashboard/dashboardEs.json')
const developersHomeEn = require('../locales/developersHome/developersHomeEn.json')
const developersHomeEs = require('../locales/developersHome/developersHomeEs.json')
const downloadManagerEn = require('../locales/downloadsManager/downloadManagerEn.json')
const downloadManagerEs = require('../locales/downloadsManager/downloadManagerEs.json')
const evaluationEn = require('../locales/evaluation/evaluationEn.json')
const evaluationEs = require('../locales/evaluation/evaluationEs.json')
const eventsEn = require('../locales/events/eventsEn.json')
const eventsEs = require('../locales/events/eventsEs.json')
const fileUploaderEn = require('../locales/fileUploader/fileUploaderEn.json')
const fileUploaderEs = require('../locales/fileUploader/fileUploaderEs.json')
const filtersEn = require('../locales/filters/filtersEn.json')
const filtersEs = require('../locales/filters/filtersEs.json')
const antifraudEn = require('../locales/antifraud/antifraudEn.json')
const antifraudEs = require('../locales/antifraud/antifraudEs.json')
const homeEn = require('../locales/home/homeEn.json')
const homeEs = require('../locales/home/homeEs.json')
const integrationAssistantEn = require('../locales/integrationAssistant/integrationAssistantEn.json')
const integrationAssistantEs = require('../locales/integrationAssistant/integrationAssistantEs.json')
const invoicingEn = require('../locales/invoicing/invoicingEn.json')
const invoicingEs = require('../locales/invoicing/invoicingEs.json')
const lifeTestEs = require('../locales/lifeTest/lifeTestEs.json')
const lifeTestEn = require('../locales/lifeTest/lifeTestEn.json')
const listsEn = require('../locales/lists/listsEn.json')
const listsEs = require('../locales/lists/listsEs.json')
const listDetailEn = require('../locales/listDetail/listDetailEn.json')
const listDetailEs = require('../locales/listDetail/listDetailEs.json')
const logsEn = require('../locales/logs/logsEn.json')
const logsEs = require('../locales/logs/logsEs.json')
const modalsEn = require('../locales/modals/modalsEn.json')
const modalsEs = require('../locales/modals/modalsEs.json')
const notificationsEn = require('../locales/notifications/notificationsEn.json')
const notificationsEs = require('../locales/notifications/notificationsEs.json')
const ordersEn = require('../locales/orders/ordersEn.json')
const ordersEs = require('../locales/orders/ordersEs.json')
const pagesEn = require('../locales/pages/pageEn.json')
const pagesEs = require('../locales/pages/pageEs.json')
const panelRoutesEn = require('../locales/panelRoutes/panelRoutesEn.json')
const panelRoutesEs = require('../locales/panelRoutes/panelRoutesEs.json')
const partnersEn = require('../locales/partners/partnersEn.json')
const partnersEs = require('../locales/partners/partnersEs.json')
const paymentDetailEn = require('../locales/paymentDetail/paymentDetailEn.json')
const paymentDetailEs = require('../locales/paymentDetail/paymentDetailEs.json')
const paymentEn = require('../locales/payments/paymentEn.json')
const paymentEs = require('../locales/payments/paymentEs.json')
const paymentLinksEn = require('../locales/paymentLinks/paymentLinksEn.json')
const paymentLinksEs = require('../locales/paymentLinks/paymentLinksEs.json')
const planDetailEn = require('../locales/planDetail/planDetailEn.json')
const planDetailEs = require('../locales/planDetail/planDetailEs.json')
const plansEn = require('../locales/plans/plansEn.json')
const plansEs = require('../locales/plans/plansEs.json')
const subscriptionsEn = require('../locales/subscriptions/subscriptionsEn.json')
const subscriptionsEs = require('../locales/subscriptions/subscriptionsEs.json')
const promotionsEn = require('../locales/promotions/promotionsEn.json')
const promotionsEs = require('../locales/promotions/promotionsEs.json')
const ruleDetailEn = require('../locales/ruleDetail/ruleDetailEn.json')
const ruleDetailEs = require('../locales/ruleDetail/ruleDetailEs.json')
const rulesEn = require('../locales/rules/rulesEn.json')
const rulesEs = require('../locales/rules/rulesEs.json')
const securityEn = require('../locales/security/securityEn.json')
const securityEs = require('../locales/security/securityEs.json')
const sendInvitationEn = require('../locales/sendInvitation/sendInvitationEn.json')
const sendInvitationEs = require('../locales/sendInvitation/sendInvitationEs.json')
const settingsEn = require('../locales/settings/settingsEn.json')
const settingsEs = require('../locales/settings/settingsEs.json')
const signatureKeysEn = require('../locales/signatureKeys/signatureKeysEn.json')
const signatureKeysEs = require('../locales/signatureKeys/signatureKeysEs.json')
const statementEn = require('../locales/statement/statementEn.json')
const statementEs = require('../locales/statement/statementEs.json')
const termsConditionsEn = require('../locales/termsConditions/termsConditionsEn.json')
const termsConditionsEs = require('../locales/termsConditions/termsConditionsEs.json')
const threeDomainSecureEn = require('../locales/threeDomainSecure/threeDomainSecureEn.json')
const threeDomainSecureEs = require('../locales/threeDomainSecure/threeDomainSecureEs.json')
const tourEn = require('../locales/tour/tourEn.json')
const tourEs = require('../locales/tour/tourEs.json')
const transferDetailEn = require('../locales/transferDetail/transferDetailEn.json')
const transferDetailEs = require('../locales/transferDetail/transferDetailEs.json')
const transfersEn = require('../locales/transfers/transfersEn.json')
const transfersEs = require('../locales/transfers/transfersEs.json')
const userEn = require('../locales/users/userEn.json')
const userEs = require('../locales/users/userEs.json')
const webhooksEn = require('../locales/webhooks/webhooksEn.json')
const webhooksEs = require('../locales/webhooks/webhooksEs.json')
const welcomeScreenEn = require('../locales/welcomeScreen/welcomeScreenEn.json')
const welcomeScreenEs = require('../locales/welcomeScreen/welcomeScreenEs.json')
const wizardEn = require('../locales/wizard/wizardEn.json')
const wizardEs = require('../locales/wizard/wizardEs.json')
const documentsEs = require('../locales/documents/documentsEs.json')
const documentsEn = require('../locales/documents/documentsEn.json')

en[enTag].adOps = adOpsEn[enTag]
es[esTag].adOps = adOpsEs[esTag]
en[enTag].apiKeys = apiKeysEn[enTag]
es[esTag].apiKeys = apiKeysEs[esTag]
en[enTag].bluebook = bluebookEn[enTag]
es[esTag].bluebook = bluebookEs[esTag]
en[enTag].cards = cardsEn[enTag]
es[esTag].cards = cardsEs[esTag]
en[enTag].carousel = carouselEn[enTag]
es[esTag].carousel = carouselEs[esTag]
en[enTag].cashout = cashoutEn
es[esTag].cashout = cashoutEs
en[enTag].cashoutDetail = cashoutDetailEn
es[esTag].cashoutDetail = cashoutDetailEs
en[enTag].changeMcc = changeMccEn[enTag]
es[esTag].changeMcc = changeMccEs[esTag]
en[enTag].chargebacks = chargebacksEn[enTag]
es[esTag].chargebacks = chargebacksEs[esTag]
en[enTag].chargebackSummary = chargebackSummaryEn[enTag]
es[esTag].chargebackSummary = chargebackSummaryEs[esTag]
en[enTag].cleanStorage = cleanStorageEn[enTag]
es[esTag].cleanStorage = cleanStorageEs[esTag]
en[enTag].companyDraft = companyDraftEn
es[esTag].companyDraft = companyDraftEs
en[enTag].companyProfile = companyProfileEn[enTag]
es[esTag].companyProfile = companyProfileEs[esTag]
en[enTag].contract = contractEn[enTag]
es[esTag].contract = contractEs[esTag]
en[enTag].createCompany = createCompanyEn[enTag]
es[esTag].createCompany = createCompanyEs[esTag]
en[enTag].customerDetail = customerDetailEn[enTag]
es[esTag].customerDetail = customerDetailEs[esTag]
en[enTag].customers = customerEn[enTag]
es[esTag].customers = customerEs[esTag]
en[enTag].dashboard = dashboardEn[enTag]
es[esTag].dashboard = dashboardEs[esTag]
en[enTag].developersHome = developersHomeEn[enTag]
es[esTag].developersHome = developersHomeEs[esTag]
en[enTag].downloadsManager = downloadManagerEn
es[esTag].downloadsManager = downloadManagerEs
en[enTag].evaluation = evaluationEn[enTag]
es[esTag].evaluation = evaluationEs[esTag]
en[enTag].events = eventsEn[enTag]
es[esTag].events = eventsEs[esTag]
en[enTag].filters = filtersEn[enTag]
es[esTag].filters = filtersEs[esTag]
en[enTag].fileUploader = fileUploaderEn[enTag]
es[esTag].fileUploader = fileUploaderEs[esTag]
en[enTag].antifraud = antifraudEn[enTag]
es[esTag].antifraud = antifraudEs[esTag]
en[enTag].home = homeEn[enTag]
es[esTag].home = homeEs[esTag]
en[enTag].integrationAssistant = integrationAssistantEn[enTag]
es[esTag].integrationAssistant = integrationAssistantEs[esTag]
en[enTag].invoicing = invoicingEn[enTag]
es[esTag].invoicing = invoicingEs[esTag]
en[enTag].lifeTest = lifeTestEn[enTag]
es[esTag].lifeTest = lifeTestEs[esTag]
en[enTag].lists = listsEn
es[esTag].lists = listsEs
en[enTag].listDetail = listDetailEn
es[esTag].listDetail = listDetailEs
en[enTag].logs = logsEn[enTag]
es[esTag].logs = logsEs[esTag]
en[enTag].modals = modalsEn
es[esTag].modals = modalsEs
en[enTag].notifications = notificationsEn
es[esTag].notifications = notificationsEs
en[enTag].orders = ordersEn
es[esTag].orders = ordersEs
en[enTag].pages = pagesEn[enTag]
es[esTag].pages = pagesEs[esTag]
en[enTag].panelRoutes = panelRoutesEn[enTag]
es[esTag].panelRoutes = panelRoutesEs[esTag]
en[enTag].partners = partnersEn
es[esTag].partners = partnersEs
en[enTag].paymentDetail = paymentDetailEn[enTag]
es[esTag].paymentDetail = paymentDetailEs[esTag]
en[enTag].payments = paymentEn[enTag]
es[esTag].payments = paymentEs[esTag]
en[enTag].paymentLinks = paymentLinksEn[enTag]
es[esTag].paymentLinks = paymentLinksEs[esTag]
en[enTag].planDetail = planDetailEn[enTag]
es[esTag].planDetail = planDetailEs[esTag]
en[enTag].plans = plansEn[enTag]
es[esTag].plans = plansEs[esTag]
en[enTag].promotions = promotionsEn[enTag]
es[esTag].promotions = promotionsEs[esTag]
en[enTag].subscriptions = subscriptionsEn[enTag]
es[esTag].subscriptions = subscriptionsEs[esTag]
en[enTag].ruleDetail = ruleDetailEn
es[esTag].ruleDetail = ruleDetailEs
en[enTag].rules = rulesEn
es[esTag].rules = rulesEs
en[enTag].security = securityEn
es[esTag].security = securityEs
en[enTag].sendInvitation = sendInvitationEn[enTag]
es[esTag].sendInvitation = sendInvitationEs[esTag]
en[enTag].settings = settingsEn[enTag]
es[esTag].settings = settingsEs[esTag]
en[enTag].signatureKeys = signatureKeysEn[enTag]
es[esTag].signatureKeys = signatureKeysEs[esTag]
en[enTag].statement = statementEn[enTag]
es[esTag].statement = statementEs[esTag]
en[enTag].termsConditions = termsConditionsEn
es[esTag].termsConditions = termsConditionsEs
en[enTag].threeDomainSecure = threeDomainSecureEn[enTag]
es[esTag].threeDomainSecure = threeDomainSecureEs[esTag]
en[enTag].tour = tourEn[enTag]
es[esTag].tour = tourEs[esTag]
en[enTag].transferDetail = transferDetailEn[enTag]
es[esTag].transferDetail = transferDetailEs[esTag]
en[enTag].transfers = transfersEn[enTag]
es[esTag].transfers = transfersEs[esTag]
en[enTag].user = userEn[enTag]
es[esTag].user = userEs[esTag]
en[enTag].webhooks = webhooksEn[enTag]
es[esTag].webhooks = webhooksEs[esTag]
en[enTag].welcomeScreen = welcomeScreenEn[enTag]
es[esTag].welcomeScreen = welcomeScreenEs[esTag]
en[enTag].wizard = wizardEn[enTag]
es[esTag].wizard = wizardEs[esTag]
es[esTag].documents = documentsEs[esTag]
en[enTag].documents = documentsEn[enTag]

export { en, es }
